export { useMedicalConsultationHistory } from './useMedicalConsultationHistory';
